<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
          >
            Ver Riedo Folio:{{folio}}
            <div>
              <CButton color="info" class="mr-1 btn-header" @click="getReporte">
                <i v-if="loader" class="fa fa-spinner fa-pulse mr-1"></i>
                <CIcon v-else class="mr-1" :name="`cil-cloud-download`" />PDF
              </CButton>
              <router-link :to="{ name: 'Riego', params: { config: config } }">
                <CButton color="primary" class="mr-1 btn-header">
                  <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
                </CButton>
              </router-link>
            </div>
          </CCardHeader>
          <CCardBody v-if="isLoading">
            <div class="w-100 d-flex justify-content-center align-items-center">
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
          </CCardBody>

          <CCardBody v-else>
            <CRow>
              <CCol sm="12" class="text-right">
                {{ this.item.author.correo }}
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <label>Fecha:</label>
                <CInput
                  :value="item.payload.encabezado.fechahora"
                  disabled
                  type="date"
                  horizontal
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <label>Ubicación:</label>
                <CInput
                  :value="
                    item.payload.encabezado._relaciones.ubicacion.payload.nombre
                  "
                  disabled
                  horizontal
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol md="3">
                <label>Entrada Lt:</label>
                <CInput
                  :value="item.payload.encabezado.entrada_lt"
                  disabled
                  horizontal
                />
              </CCol>
              <CCol md="3">
                <label>Salida Lt:</label>
                <CInput
                  :value="item.payload.encabezado.salida_lt"
                  disabled
                  horizontal
                />
              </CCol>
              <CCol md="3">
                <label>Drenado:</label>
                <CInput
                  :value="
                    `${$formatter(
                      100 *
                        (item.payload.encabezado.salida_lt /
                          item.payload.encabezado.entrada_lt)
                    )}%`
                  "
                  disabled
                  horizontal
                />
              </CCol>
            </CRow>
            
            <CRow>
              <CCol md="9">
                <CRow>
                  <CCol md="6">
                    <label>Entrada pH:</label>
                    <CInput
                      :value="item.payload.encabezado.entrada_ph"
                      disabled
                      horizontal
                    />
                  </CCol>
                  <CCol md="6">
                    <label>Salida pH:</label>
                    <CInput
                      :value="item.payload.encabezado.salida_ph"
                      disabled
                      horizontal
                    />
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
            
            <CRow>
              <CCol md="9">
                <CRow>
                  <CCol md="6">
                    <label>Entrada Ce:</label>
                    <CInput
                      :value="item.payload.encabezado.entrada_ce"
                      disabled
                      horizontal
                    />
                  </CCol>
                  <CCol md="6">
                    <label>Salida Ce:</label>
                    <CInput
                      :value="item.payload.encabezado.salida_ce"
                      disabled
                      horizontal
                    />
                  </CCol>
                </CRow>
              </CCol>
            </CRow>

            <CRow>
              <CCol>
                <label>Comentarios:</label>
                <CTextarea v-model="comentarios" disabled horizontal />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <KlayFileDD
                  :fetching="fetching"
                  v-model="medias"
                  :label="`Anexos: `"
                  @onFetch="onFetch"
                  @onErrorFetch="(err)=>{
                    fetching=false;
                    error=err
                    warningModal=true
                  }"
                  :fetchMethod="pushMedia"
                  :baseSrc="$store.getters.MediaGet"
                />
              </CCol>
            </CRow>
            <CRow>
              <CButton v-if="fetching" class="px-4 mx-3 btn-lg" color="success">
                <i class="fa fa-spinner fa-pulse"></i>
              </CButton>
              <CButton
                v-else
                @click="
                  () => {
                    fetching = true;
                  }
                "
                class="px-4 mx-3 btn-lg"
                color="success"
              >
                <span>Actualizar</span>
              </CButton>
            </CRow>
            <CModal
              size="sm"
              title="Riedo"
              :centered="true"
              color="warning"
              :show.sync="warningModal"
              >{{ error }}</CModal
            >
            <CModal
              size="sm"
              title="Riedo"
              :centered="true"
              color="success"
              :show.sync="successModal"
              >Guardado con éxito.
              <template #footer>
                <CButton @click="successModal = false" color="success"
                  >Aceptar</CButton
                >
              </template>
            </CModal>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: "VerLabor",

  components: {
    
  },

  data() {
    return {
      folio: this.$route.params.id,
      config: this.$route.params.config,
      item: {},
      date: null,
      multi: null,
      cantidad: 1,
      cantidadCosto: 0,
      trabajador: null,
      trabajadores: [],
      trabajadoresAll: [],
      comentarios: '',
      categoriasAll: [],
      actividad: null,
      actividades: [],
      actividadesAll: [],
      ubicacion: null,
      ubicaciones: [],
      ubicacionesAll: [],
      isLoading: false,
      tiempo_extra: false,
      isFijo: false,
      successModal: false,
      warningModal: false,
      error: "",
      isLoadingPage: false,
      currentAlertCounter: 0,
      fetching: false,
      medias:[],
      loader: false,
    };
  },

  computed: {
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  created() {
    this.isLoading = true;
    this.$store;

    const ubi = [
      this.$store.dispatch("customDocumentoHTTP", {
        schema: "riego",
        filter: {
          wherein: [
            {
              field: "payload->encabezado->ubicacion_raiz_id",
              value: [this.ubicacionRaiz]
            }
          ],
          where: [
            {
              field: "folio",
              value: this.folio,
              operator: "="
            }
          ]
        },
        ["with-storage"]: ["*"]
      })
    ];

    Promise.all(ubi)
      .then(([item]) => {
        this.item = item.data[0];
        
        this.item.payload.encabezado.fechahora = moment(this.item.payload.encabezado.fechahora,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
        
        this.medias = this.item.payload.anexos;
        this.filtrarActividad();

      })
      .finally(() => (this.isLoading = false));
  },

  methods: {
    getReporte(index,item){
      if(this.loader){
        return
      }
      this.loader = true
      this.$forceUpdate();
      const reportCall = {
        reporte: "formato_labores",
        params: { folio:this.$route.params.id, ubicaciones: [this.ubicacionRaiz]},
        pdf : true
      };

      // console.log(reportCall);
      // call.push(reportCall);

      
        this.$store.dispatch("reportsPDFHttp", {
          ...reportCall
        }).then(res => {

          const blob = res;

          let a = document.createElement("a");
          a.style = "display: none";
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = "Reporte de riego.pdf";
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(rej => {
          // console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
        })

        .finally(() => {
          this.loader = false
          this.$forceUpdate();
        });
    },
    async onFetch(medias){
      this.fetching=false
      const {folio,serie,schema,payload} = this.item
      const body = Object.assign({},JSON.parse(JSON.stringify({folio,serie,schema,payload})))
      body.payload.anexos = medias
      delete body.payload.encabezado._relaciones
      this.$store.dispatch("customDocumentoRemplazarHTTP",body)
        .then(res=>{
          this.currentAlertCounter = 6;
            // console.log(res.data);
            // this.$router.push({ name: "Produccion" });
        })
        .catch(rej => {
          // console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
          this.fetching=false
          return;
        })

        .finally(() => {
          this.fetching=false
          if (!this.warningModal) {
            this.successModal = true;
          }
        });
      
    },
    async pushMedia(files) {
      const arr = [];
      
      for (const v of files.map(async (m) => {
        // eslint-disable-next-line no-extra-boolean-cast
        if(!!m.media){
          return Promise.resolve({data:m,status:"success"})
        }
        const formData = new FormData();
        formData.append("media", m);
        const promise = await this.$store.dispatch("customImageHTTP", formData);

        return promise;
      })) {
        const media = await v;
        if (media.status === "success") {
          arr.push(media.data);
        }
      }
      return arr;
      /*
        const formData = new FormData()
        formData.append('media', format.dataURLtoFile(this.fileList[0].thumbUrl))
        this.$store.dispatch('MEDIA_CARGAR', formData)
      */
    },
    getUnidad() {
      if (this.actividad) {
        const actSelect = this.actividadesAll.find(
          actividad => actividad.id == this.actividad
        );
        console.log(actSelect);

        return actSelect ? ` (${actSelect.payload.unidad})` : "";
      }
      return "";
    },
    getUnidadPagar() {
      if (this.actividad && this.trabajador) {
        let tipo_pago = "";
        const actSelect = this.actividadesAll.find(
          actividad => actividad.id == this.actividad
        );
        actSelect ? (tipo_pago = actSelect.payload.tipo_pago) : "";

        if (tipo_pago == "fijo") {
          const trabSelect = this.trabajadoresAll.find(
            trabajador => trabajador.id == this.trabajador
          );
          if (trabSelect) {
            return this.tiempo_extra
              ? ` (${trabSelect.payload.unidad_extra})`
              : ` (${trabSelect.payload.unidad})`;
          }
        }
      }
      return "";
    },
    filtrarActividad() {
      if (this.actividad) {
        const actSelect = this.actividadesAll.find(
          actividad => actividad.id == this.actividad
        );
        if (actSelect) {
          actSelect.payload.tipo_pago === "fijo"
            ? (this.isFijo = true)
            : (this.isFijo = false);
        }
      }
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 12px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
